import { render, staticRenderFns } from "./WorkShiftsFormPage.vue?vue&type=template&id=17a30d69&"
import script from "./WorkShiftsFormPage.vue?vue&type=script&lang=js&"
export * from "./WorkShiftsFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports